document.addEventListener('DOMContentLoaded', () => {

  // === VARIANT LOGIC (Size) ===
  const sizeButtons = document.querySelectorAll('.detail__size-option');
  const priceElement = document.getElementById('product-price');
  const variantInput = document.getElementById('variant-id-input'); // hidden del form
  const productForm = document.getElementById('product-form');

  // 1) Marcar activa la variante inicial (por URL ?variant= o la primera disponible)
  (function initActiveVariant() {
    if (!sizeButtons.length) return;
    const urlVariant = new URL(window.location.href).searchParams.get('variant');
    let activated = false;

    sizeButtons.forEach(btn => {
      const vid = btn.dataset.variantId;
      if (urlVariant && vid === urlVariant) {
        btn.classList.add('active');
        if (variantInput) variantInput.value = vid;
        if (priceElement) priceElement.textContent = btn.dataset.variantPrice;
        activated = true;
      }
    });

    if (!activated) {
      // Si no había ?variant= en la URL, activa la primera
      const first = sizeButtons[0];
      first.classList.add('active');
      if (variantInput) variantInput.value = first.dataset.variantId;
      if (priceElement) priceElement.textContent = first.dataset.variantPrice;
    }
  })();

  // 2) Click en tamaños: resaltar, actualizar precio y hidden, y reflejar en URL
  sizeButtons.forEach(button => {
    button.addEventListener('click', () => {
      sizeButtons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      const newPrice = button.dataset.variantPrice;
      const variantId = button.dataset.variantId;

      if (priceElement) priceElement.textContent = newPrice;
      if (variantInput) variantInput.value = variantId;

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);
    });
  });

  // 3) Validación al enviar (por si alguien no clicó nada)
  if (productForm) {
    productForm.addEventListener('submit', (e) => {
      if (!variantInput || !variantInput.value) {
        e.preventDefault();
        alert('Por favor, selecciona un tamaño antes de continuar.');
      }
    });
  }

  // --- FUNCIÓN HELPER PARA FORMATEAR PRECIOS ---
  const formatMoney = (cents, format) => {
    if (typeof cents === 'string') { cents = cents.replace('.', ''); }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = (format || '${{amount}}');
    function defaultOption(opt, def) { return (typeof opt == 'undefined' ? def : opt); }
    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) { return 0; }
      number = (number / 100.0).toFixed(precision);
      let parts = number.split('.');
      let dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      let centsValue = parts[1] ? (decimal + parts[1]) : '';
      return dollars + centsValue;
    }
    try {
      switch (formatString.match(placeholderRegex)[1]) {
        case 'amount': value = formatWithDelimiters(cents, 2); break;
        case 'amount_no_decimals': value = formatWithDelimiters(cents, 0); break;
        case 'amount_with_comma_separator': value = formatWithDelimiters(cents, 2, '.', ','); break;
        case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(cents, 0, '.', ','); break;
        default: value = formatWithDelimiters(cents, 2);
      }
    } catch (e) {
      value = formatWithDelimiters(cents, 2);
    }
    return formatString.replace(placeholderRegex, value);
  };
  
  // --- FUNCIÓN PARA ACTUALIZAR LA BARRA DE ENVÍO GRATIS ---
  const updateFreeShippingBar = (newSubtotal) => {
    const shippingWrapper = document.querySelector('.cart_free-shipping-wrapper');
    if (!shippingWrapper) return;
    const goal = parseInt(shippingWrapper.dataset.goalInCents);
    if (isNaN(goal) || goal <= 0) return;
    const textElement = shippingWrapper.querySelector('p');
    const progressBar = shippingWrapper.querySelector('.free-shipping_top-bar');
    if (!textElement || !progressBar) return;
    if (newSubtotal >= goal) {
      textElement.innerHTML = 'Congratulation! <span>You have FREE SHIPPING!.</span>';
      progressBar.style.width = '100%';
    } else {
      const remaining = goal - newSubtotal;
      const progressPercentage = (newSubtotal / goal) * 100;
      const remainingFormatted = formatMoney(remaining, window.Shopify.money_format);
      textElement.innerHTML = `You are <span>${remainingFormatted}</span> away from <span>FREE SHIPPING!</span>`;
      progressBar.style.width = `${progressPercentage}%`;
    }
  };

  // --- FUNCIÓN PARA ACTUALIZAR EL HTML DEL CARRITO ---
  // --- FUNCIÓN PARA ACTUALIZAR EL HTML DEL CARRITO ---
  const updateCartDrawer = (refreshItems = false, refreshFooter = false) => {
    return fetch(window.location.href)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const newItems = html.querySelector('.cart_items-wrapper');
        const newFooter = html.querySelector('.cart_checkout-wrapper');
        const newFreeShipping = html.querySelector('.cart_free-shipping-wrapper');
        const newCartCount = html.querySelector('.header__right-wrapper .cart-count');
        const newEnjoyWrapper = html.querySelector('.cart_enjoy-wrapper');
        
        const currentItems = document.querySelector('.cart_items-wrapper');
        const currentFooter = document.querySelector('.cart_checkout-wrapper');
        const currentFreeShipping = document.querySelector('.cart_free-shipping-wrapper');
        const currentCartCount = document.querySelector('.header__right-wrapper .cart-count');
        const currentEnjoyWrapper = document.querySelector('.cart_enjoy-wrapper');
        
        if (refreshItems && newItems && currentItems) {
          currentItems.innerHTML = newItems.innerHTML;
        }

        // Lógica del footer (Checkout y Subtotal)
        if (refreshFooter && newFooter && currentFooter) { 
          currentFooter.innerHTML = newFooter.innerHTML;
        } else if (newFooter && !currentFooter) {
          const cartForm = document.querySelector('.cart_checkout-form');
          if(cartForm) {
              cartForm.appendChild(newFooter);
              const emptyCartMessage = document.querySelector('.cart_empty');
              if (emptyCartMessage) emptyCartMessage.style.display = 'none';
          }
        }
        else if (!newFooter && currentFooter) { 
          currentFooter.remove(); // Aquí es donde desaparece el subtotal si está vacío
        }
        
        if (newFreeShipping && currentFreeShipping && !refreshFooter) { 
          currentFreeShipping.innerHTML = newFreeShipping.innerHTML;
         }
        if (newCartCount && currentCartCount) { currentCartCount.innerHTML = newCartCount.innerHTML; }
        if (newEnjoyWrapper && currentEnjoyWrapper) { currentEnjoyWrapper.innerHTML = newEnjoyWrapper.innerHTML; }
        else if (!newEnjoyWrapper && currentEnjoyWrapper) { currentEnjoyWrapper.remove(); }
        
        // === CORRECCIÓN AQUÍ ===
        // Intentamos leer el subtotal nuevo
        const subtotalElement = document.querySelector('.cart_subtotal-price');
        let newSubtotal = 0; // Por defecto asumimos 0 (carrito vacío)

        if (subtotalElement) {
           // Si existe el elemento, leemos su valor real
           newSubtotal = parseInt(subtotalElement.dataset.subtotal || '0');
        }
        
        // Actualizamos la barra SIEMPRE, ya sea con el valor real o con 0
        updateFreeShippingBar(newSubtotal);
      })
      .catch(e => { console.error(e); });
    };

  // --- FUNCIONES PARA ABRIR Y CERRAR EL CARRITO ---
  const openCartDrawer = () => {
    const cartSection = document.querySelector('.cart_section');
    const cartWrapper = document.querySelector('.cart_content-wrapper');
    if (!cartSection || !cartWrapper) return;
    cartSection.classList.add('active');
    setTimeout(() => { cartWrapper.classList.add('active'); }, 10);
    document.body.classList.add('no-scroll');
  };
  const closeCartDrawer = () => {
    const cartSection = document.querySelector('.cart_section');
    const cartWrapper = document.querySelector('.cart_content-wrapper');
    if (!cartSection || !cartWrapper) return;
    cartWrapper.classList.remove('active');
    setTimeout(() => { cartSection.classList.remove('active'); }, 400);
    document.body.classList.remove('no-scroll');
  };

  // --- FUNCIÓN PARA CAMBIAR LA CANTIDAD DE UN ITEM ---
  const updateQuantity = (lineKey, newQuantity) => {
    const cartSection = document.querySelector('.cart_section');
    cartSection.classList.add('is-loading'); // Muestra loading
    
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: { [lineKey]: newQuantity } })
    })
    .then(response => response.json())
    .then(data => {
      // === CAMBIO CRÍTICO AQUÍ ===
      // Cambiado a (true, true) para forzar el repintado del HTML con los precios corregidos por el servidor
      updateCartDrawer(true, true).then(() => { 
          cartSection.classList.remove('is-loading'); 
      });
    })
    .catch(e => { console.error(e); cartSection.classList.remove('is-loading'); });
  };
  
  // --- EVENT LISTENER PARA AÑADIR AL CARRITO (AJAX) ---
  document.body.addEventListener('submit', (event) => {
    if (event.target && event.target.matches('.product-form')) {
      event.preventDefault();
      event.stopPropagation();
      const form = event.target;
      const submitButton = form.querySelector('button[type="submit"]');
      const buttonTextSpan = submitButton.querySelector('.btn-text');
      let originalButtonText;
      if (buttonTextSpan) {
        originalButtonText = buttonTextSpan.textContent;
        buttonTextSpan.textContent = 'Adding...';
      }
      submitButton.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form),
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === 422) {
          alert(data.description);
          if (buttonTextSpan) buttonTextSpan.textContent = originalButtonText;
          submitButton.disabled = false;
        } else {
          if (buttonTextSpan) buttonTextSpan.textContent = 'Added!';
          updateCartDrawer(true, true).then(() => {
            openCartDrawer();
          });
          setTimeout(() => {
            if (buttonTextSpan) buttonTextSpan.textContent = originalButtonText;
            submitButton.disabled = false;
          }, 2000);
        }
      })
      .catch(error => { console.error('Error:', error); if (buttonTextSpan) buttonTextSpan.textContent = originalButtonText; submitButton.disabled = false; });
    }
  });
  
  const openBtn = document.querySelector('.js-open-cart-btn');
  if (openBtn) {
    openBtn.addEventListener('click', (event) => {
      event.preventDefault();
      openCartDrawer();
    });
  }

  // --- EVENT LISTENER PARA CLICS EN EL CARRITO ---
  let debounceTimer;
  document.body.addEventListener('click', (event) => {
    const cartSection = document.querySelector('.cart_section');
    
    // 1. Cerrar carrito
    if (event.target.matches('.cart_close-button') || event.target === cartSection) {
      closeCartDrawer();
    }
    
    // 2. Botón Eliminar
    const deleteButton = event.target.closest('.cart_item-delete-button');
    if (deleteButton) {
      event.preventDefault();
      event.stopPropagation();
      const itemElement = deleteButton.closest('.cart_item-example');
      if (!itemElement) return;
      
      const lineKey = itemElement.dataset.lineKey;
      
      // Eliminamos visualmente para que sea rápido
      itemElement.remove();
      
      const remainingItems = document.querySelectorAll('.cart_item-example');
      if (remainingItems.length === 0) {
        const checkoutWrapper = document.querySelector('.cart_checkout-wrapper');
        if (checkoutWrapper) checkoutWrapper.style.display = 'none';
        const emptyCartMessage = document.querySelector('.cart_empty');
        if (emptyCartMessage) emptyCartMessage.style.display = 'block';
      }
      
      // Llamada AJAX
      updateQuantity(lineKey, 0);
    }
    
    // 3. Botones Cantidad (+ / -)
    const quantityButton = event.target.closest('.quantity-button');
    if (quantityButton) {
      event.preventDefault();
      event.stopPropagation();
      const itemElement = quantityButton.closest('.cart_item-example');
      if (!itemElement) return;
      
      const lineKey = itemElement.dataset.lineKey;
      const quantityElement = itemElement.querySelector('.counter-number_wrapper p');
      const currentQuantity = parseInt(quantityElement.textContent);
      
      let newQuantity;
      if (quantityButton.classList.contains('up')) {
        newQuantity = currentQuantity + 1;
      } else if (quantityButton.classList.contains('down')) {
        newQuantity = currentQuantity - 1;
      }

      // Si es 0, borrar
      if (newQuantity === 0) {
        const correspondingDeleteButton = itemElement.querySelector('.cart_item-delete-button');
        if(correspondingDeleteButton) correspondingDeleteButton.click();
        return;
      }
      
      if (newQuantity > 0) {
        // === OPTIMISTIC UI: SOLO ACTUALIZAMOS EL NÚMERO ===
        // No tocamos precios aquí. Dejamos que updateQuantity traiga el HTML correcto del servidor.
        quantityElement.textContent = newQuantity;

        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
          updateQuantity(lineKey, newQuantity);
        }, 200);
      }
    }
  });
});